import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinpune() {



  const cardData = {




keyword: "Ertiga On Rent in Pune",

headingDescription: "Garud Cab Service provides comfortable and spacious Ertiga on Rent in Pune for family travel, airport transfers, corporate transportation, local journeys, outstation trips, sightseeing, and long-distance travel. The Ertiga offers comfortable seating, generous luggage space, and a practical cabin for families and small groups. Customers can book an Ertiga with a professional chauffeur for one-way journeys, round trips, airport pickup and drop, and customized travel plans. With clean and well-maintained vehicles, experienced drivers, flexible pickup locations, transparent pricing, and 24/7 customer assistance, Garud Cab Service provides a convenient and reliable Ertiga rental experience from Pune to popular destinations across Maharashtra and nearby states.",

topPlaces: [
 
    {
    title: "Goa",
    description: "Goa is a popular long-distance destination from Pune for beach vacations, family holidays, group tours, and weekend getaways. The Ertiga provides comfortable seating and practical luggage capacity for the extended road journey. Customers can arrange a private chauffeur-driven Ertiga for one-way or round-trip Goa travel according to their preferred schedule."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a beautiful hill destination famous for viewpoints, strawberry farms, Venna Lake, waterfalls, and cool mountain surroundings. Families and groups can choose an Ertiga for a comfortable journey from Pune with sufficient space for passengers and luggage. The vehicle can be booked for direct travel, round trips, or a customized Mahabaleshwar sightseeing itinerary."
  },
  {
    title: "Shirdi",
    description: "Shirdi is an important pilgrimage destination visited by devotees throughout the year for Sai Baba Darshan. An Ertiga provides a comfortable option for families and small groups traveling from Pune, particularly when passengers need additional luggage space. Garud Cab Service offers chauffeur-driven Ertiga bookings for one-way travel, return journeys, and religious tours."
  },
  {
    title: "Nashik",
    description: "Nashik is a major destination in Maharashtra known for Trimbakeshwar, Panchavati, temples, vineyards, and scenic surroundings. Travelers from Pune can rent an Ertiga for family visits, religious journeys, business travel, and sightseeing. The spacious MUV is suitable for passengers traveling together and can be booked with a professional driver."
  },

   {
    title: "Lonavala",
    description: "Lonavala is a popular destination near Pune known for waterfalls, mountain valleys, forts, lakes, and scenic monsoon landscapes. An Ertiga is a practical choice for families and small groups traveling together, offering comfortable seating and useful luggage space. Garud Cab Service provides chauffeur-driven Ertiga rentals from Pune for one-way journeys, return trips, and customized sightseeing plans."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is known for Mahalaxmi Temple, Panhala Fort, Rankala Lake, traditional cuisine, and rich cultural heritage. An Ertiga is well suited for families and groups traveling from Pune to Kolhapur because of its spacious interior and comfortable seating. Garud Cab Service provides flexible rental options for direct journeys and sightseeing."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination known for beaches, sea forts, coastal villages, and peaceful weekend experiences. Families and groups can rent an Ertiga from Pune for convenient travel with luggage and flexible stopping options. The vehicle is suitable for one-way journeys, return trips, and customized Alibaug sightseeing."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad is a prominent heritage destination featuring Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Jyotirlinga. An Ertiga offers a comfortable travel solution for families and groups planning the longer journey from Pune. Customers can also customize their rental itinerary to include multiple historical and religious attractions."
  },
  {
    title: "Satara",
    description: "Satara offers beautiful Sahyadri landscapes and access to destinations such as Kaas Plateau, Thoseghar Waterfalls, and Ajinkyatara Fort. It is suitable for nature trips, family outings, and weekend travel from Pune. An Ertiga provides a comfortable option for small groups looking for spacious seating and convenient chauffeur-driven transportation."
  },
  {
    title: "Solapur",
    description: "Solapur is an important Maharashtra city visited for business, family functions, religious travel, and personal work. The journey from Pune is convenient in an Ertiga, especially for families and groups traveling together. Garud Cab Service provides professional chauffeur-driven Ertiga rentals with flexible pickup arrangements and one-way or round-trip booking options."
  }
],



"services": [
{
"name": "Ertiga on Rent in Pune",
"description": "Book Ertiga on Rent in Pune for comfortable and spacious chauffeur-driven travel with a well-maintained air-conditioned vehicle. Maruti Ertiga is suitable for family trips, airport transfers, local travel, corporate transportation, sightseeing, outstation journeys, and group travel with convenient pickup and drop arrangements."
},
{
"name": "Ertiga on Rent Pune",
"description": "Choose Ertiga on Rent Pune for reliable and comfortable transportation with spacious seating, practical luggage capacity, powerful AC, and professional chauffeur service. The vehicle is suitable for family travel, business trips, airport transfers, weekend journeys, sightseeing, and long-distance outstation transportation."
},
{
"name": "Ertiga Car on Rent in Pune",
"description": "Hire Ertiga Car on Rent in Pune for convenient private transportation with a professional chauffeur and comfortable AC interiors. The spacious MUV is suitable for families, small groups, corporate travelers, airport transfers, sightseeing, local travel, and outstation journeys requiring comfortable seating and luggage space."
},
{
"name": "Ertiga CNG on Rent in Pune",
"description": "Book Ertiga CNG on Rent in Pune for an economical and comfortable chauffeur-driven travel option. Enjoy spacious seating, air-conditioned interiors, convenient pickup, and professional driver service for local travel, airport transfers, family trips, corporate journeys, sightseeing, and selected outstation routes."
},
{
"name": "Ertiga Rent in Pune",
"description": "Reserve Ertiga Rent in Pune for flexible and comfortable travel with a spacious MUV, clean AC interiors, and an experienced chauffeur. The service is suitable for family outings, airport transfers, corporate travel, sightseeing, local transportation, weekend trips, and long-distance journeys."
},
{
"name": "Ertiga Rent Per Km in Pune",
"description": "Get Ertiga Rent Per Km in Pune with flexible travel options based on your selected route and journey requirements. Choose a comfortable chauffeur-driven Ertiga for local trips, airport transfers, business travel, family journeys, sightseeing, and outstation transportation according to distance, passenger count, luggage, and travel duration."
},
{
"name": "Ertiga Rental Pune",
"description": "Choose Ertiga Rental Pune for dependable chauffeur-driven transportation with spacious seating, comfortable interiors, air conditioning, and useful luggage capacity. The service is suitable for family vacations, corporate travel, airport transfers, sightseeing, local journeys, religious trips, and outstation transportation."
},
{
"name": "Maruti Ertiga on Rent in Pune",
"description": "Book Maruti Ertiga on Rent in Pune for practical and comfortable private transportation with professional chauffeur service. Enjoy spacious seating, AC interiors, convenient luggage capacity, and flexible pickup arrangements for family travel, business visits, airport transfers, sightseeing, weekend trips, and outstation journeys."
},
{
"name": "Ertiga Cab in Pune",
"description": "Reserve an Ertiga Cab in Pune for comfortable chauffeur-driven transportation with spacious seating and air-conditioned interiors. The vehicle is suitable for airport transfers, local travel, family outings, corporate journeys, sightseeing, business visits, and outstation trips with convenient pickup and drop facilities."
},
{
"name": "Ertiga Taxi in Pune",
"description": "Choose Ertiga Taxi in Pune for reliable and spacious private transportation with experienced chauffeurs and comfortable AC travel. The service is suitable for families, groups, tourists, corporate travelers, airport passengers, and customers requiring convenient local or outstation transportation."
},
{
"name": "Ertiga Car Rental Pune",
"description": "Hire Ertiga Car Rental Pune for comfortable chauffeur-driven travel with practical seating capacity, clean interiors, air conditioning, and luggage space. It is suitable for family trips, business travel, airport transfers, sightseeing, local transportation, weekend journeys, and outstation travel."
},
{
"name": "Ertiga Hire in Pune",
"description": "Book Ertiga Hire in Pune for convenient and comfortable transportation with a professional chauffeur and well-maintained AC vehicle. The Ertiga is suitable for family functions, airport transfers, corporate travel, sightseeing, local trips, weekend travel, and long-distance outstation journeys."
},
{
"name": "Ertiga Cab Service Pune",
"description": "Choose Ertiga Cab Service Pune for dependable transportation with professional chauffeurs, spacious seating, clean AC interiors, and convenient pickup and drop arrangements. The service can be used for airport transfers, corporate travel, family journeys, sightseeing, local transportation, and outstation trips."
},
{
"name": "Ertiga Taxi Service Pune",
"description": "Book Ertiga Taxi Service Pune for comfortable private travel with experienced drivers and spacious air-conditioned vehicles. The service is suitable for individuals, families, corporate travelers, tourists, and groups requiring reliable transportation for local travel, airport transfers, sightseeing, business visits, and outstation journeys."
},
{
"name": "Ertiga Airport Cab Pune",
"description": "Reserve Ertiga Airport Cab Pune for convenient airport pickup and drop with comfortable seating and ample luggage capacity. Professional chauffeurs provide private AC transportation to and from Pune Airport, making the service suitable for families, corporate passengers, tourists, and groups carrying multiple bags."
},
{
"name": "Ertiga Outstation Cab Pune",
"description": "Book Ertiga Outstation Cab Pune for comfortable long-distance travel with a professional chauffeur, spacious seating, air conditioning, and luggage-friendly interiors. The service is suitable for family vacations, weekend trips, business travel, sightseeing, religious journeys, one-way drops, and round-trip outstation transportation."
},
{
"name": "Ertiga Local Cab Pune",
"description": "Choose Ertiga Local Cab Pune for spacious and convenient city transportation with flexible travel arrangements. The vehicle is suitable for family outings, shopping trips, corporate meetings, events, sightseeing, hotel transfers, local appointments, and customers who prefer a comfortable chauffeur-driven MUV within Pune."
},
{
"name": "Ertiga Corporate Cab Pune",
"description": "Arrange Ertiga Corporate Cab Pune for comfortable employee and business transportation with professional chauffeurs, clean AC interiors, spacious seating, and reliable scheduling. The service is suitable for office travel, business meetings, client visits, corporate events, airport transfers, and employee transportation requirements."
},
{
"name": "Ertiga Family Cab Pune",
"description": "Book Ertiga Family Cab Pune for comfortable and spacious family transportation with useful luggage capacity and professional chauffeur service. The vehicle is suitable for vacations, airport transfers, family functions, sightseeing, weekend trips, religious journeys, and long-distance travel with comfortable AC interiors."
},
{
"name": "Ertiga Wedding Cab Pune",
"description": "Reserve Ertiga Wedding Cab Pune for convenient family and guest transportation during weddings and special events. Spacious seating, comfortable AC interiors, luggage capacity, and professional chauffeur service make the Ertiga suitable for venue transfers, guest movement, family travel, and wedding-related transportation."
},
{
"name": "Pune to Mumbai Ertiga Cab",
"description": "Book Pune to Mumbai Ertiga Cab for comfortable intercity travel with spacious seating, air-conditioned interiors, luggage capacity, and professional chauffeur service. The vehicle is suitable for families, corporate travelers, airport transfers, business visits, personal journeys, one-way drops, and round-trip travel between Pune and Mumbai."
},
{
"name": "Pune Airport to Ertiga Cab",
"description": "Choose Pune Airport to Ertiga Cab for convenient airport transportation with direct pickup, comfortable AC travel, spacious seating, and ample luggage capacity. Professional chauffeurs provide private transfers for families, business travelers, tourists, and groups arriving at or departing from Pune Airport."
},
{
"name": "Pune to Nashik Ertiga Cabs",
"description": "Reserve Pune to Nashik Ertiga Cabs for a comfortable and spacious journey between Pune and Nashik with an experienced chauffeur. The Ertiga is suitable for families, corporate travelers, tourists, religious trips, personal visits, sightseeing, one-way transfers, and round-trip journeys."
},
{
"name": "Pune to Shirdi Ertiga Cab",
"description": "Book Pune to Shirdi Ertiga Cab for a comfortable religious journey with spacious seating, air conditioning, luggage capacity, and professional chauffeur service. The vehicle is suitable for families, senior passengers, groups, and travelers planning one-way, round-trip, or sightseeing trips to Shirdi."
},
{
"name": "Pune to Goa Ertiga Cab",
"description": "Choose Pune to Goa Ertiga Cab for comfortable long-distance travel with spacious seating, clean AC interiors, useful luggage capacity, and an experienced chauffeur. The vehicle is suitable for family vacations, group travel, weekend trips, corporate journeys, sightseeing, and one-way or round-trip Goa travel."
},
{
"name": "Pune to Kolhapur Ertiga Cab",
"description": "Reserve Pune to Kolhapur Ertiga Cab for convenient and comfortable intercity transportation with a professional chauffeur and spacious AC vehicle. The service is suitable for family trips, business travel, personal visits, sightseeing, one-way drops, and round-trip journeys between Pune and Kolhapur."
},
{
"name": "Ertiga Cab in Hinjewadi",
"description": "Book Ertiga Cab in Hinjewadi for comfortable chauffeur-driven transportation suitable for corporate travel, airport transfers, family journeys, local travel, and outstation trips. Enjoy spacious seating, air conditioning, professional drivers, convenient pickup, and flexible travel arrangements from Hinjewadi to Pune and other destinations."
},
{
"name": "Ertiga Cab in Wakad",
"description": "Choose Ertiga Cab in Wakad for spacious and reliable transportation with comfortable AC interiors and professional chauffeur service. The vehicle is suitable for airport transfers, corporate travel, family trips, local journeys, sightseeing, weekend travel, and outstation transportation from Wakad to various destinations."
},
{
"name": "Ertiga Cab in Baner",
"description": "Reserve Ertiga Cab in Baner for comfortable private transportation with experienced chauffeurs and convenient pickup and drop facilities. The service is suitable for business meetings, airport transfers, family travel, hotel transfers, local sightseeing, corporate transportation, and outstation trips from Baner."
},
{
"name": "Ertiga Cab in Hadapsar",
"description": "Book Ertiga Cab in Hadapsar for dependable and spacious transportation with clean AC interiors, comfortable seating, and professional chauffeur service. The vehicle is suitable for corporate travel, airport transfers, family journeys, local transportation, sightseeing, business visits, and outstation trips from Hadapsar."
},
{
"name": "Ertiga Cab in Kharadi",
"description": "Hire Ertiga Cab in Kharadi for comfortable and convenient transportation with spacious seating, luggage capacity, air conditioning, and professional chauffeurs. The service is suitable for corporate travelers, airport passengers, families, tourists, local travel, and outstation journeys from Kharadi."
},
{
"name": "Ertiga Cab in Pimpri Chinchwad",
"description": "Choose Ertiga Cab in Pimpri Chinchwad for comfortable chauffeur-driven transportation suitable for families, corporate travelers, airport transfers, sightseeing, local travel, and outstation journeys. Enjoy a spacious AC vehicle with practical luggage capacity, professional service, and flexible pickup arrangements."
},
{
"name": "Ertiga on Rent Near Me Pune",
"description": "Find Ertiga on Rent Near Me Pune for convenient and spacious chauffeur-driven transportation from your preferred pickup location. Enjoy quick booking arrangements, comfortable AC interiors, professional drivers, and flexible travel options for airport transfers, local trips, family journeys, corporate travel, sightseeing, and outstation destinations."
}
],
"tableData": [
["Ertiga on Rent in Pune", "Ertiga on Rent Pune"],
["Ertiga Car on Rent in Pune", "Ertiga CNG on Rent in Pune"],
["Ertiga Rent in Pune", "Ertiga Rent Per Km in Pune"],
["Ertiga Rental Pune", "Maruti Ertiga on Rent in Pune"],
["Ertiga Cab in Pune", "Ertiga Taxi in Pune"],
["Ertiga Car Rental Pune", "Ertiga Hire in Pune"],
["Ertiga Cab Service Pune", "Ertiga Taxi Service Pune"],
["Ertiga Airport Cab Pune", "Ertiga Outstation Cab Pune"],
["Ertiga Local Cab Pune", "Ertiga Corporate Cab Pune"],
["Ertiga Family Cab Pune", "Ertiga Wedding Cab Pune"],
["Pune to Mumbai Ertiga Cab", "Pune Airport to Ertiga Cab"],
["Pune to Nashik Ertiga Cabs", "Pune to Shirdi Ertiga Cab"],
["Pune to Goa Ertiga Cab", "Pune to Kolhapur Ertiga Cab"],
["Ertiga Cab in Hinjewadi", "Ertiga Cab in Wakad"],
["Ertiga Cab in Baner", "Ertiga Cab in Hadapsar"],
["Ertiga Cab in Kharadi", "Ertiga Cab in Pimpri Chinchwad"],
["Ertiga on Rent Near Me Pune", ""]
],



whychoose: [
  {
    WhyChooseheading: "Ertiga on Rent in Pune for Comfortable Group Travel",
    WhyChoosedescription: "Garud Cab Service offers Ertiga rental options in Pune for families, small groups, airport transfers, local travel, outstation trips, events, and customers who need a spacious vehicle for convenient transportation."
  },
  {
    WhyChooseheading: "Spacious Vehicle for Families",
    WhyChoosedescription: "The Ertiga provides a practical combination of seating space and luggage capacity, making it a suitable rental choice for families and groups travelling together around Pune or to nearby destinations."
  },
  {
    WhyChooseheading: "Available for Local & Outstation Requirements",
    WhyChoosedescription: "Hire an Ertiga for city travel in Pune or plan longer journeys to destinations outside the city. The rental arrangement can be selected according to your route and travel duration."
  },
  {
    WhyChooseheading: "Convenient Airport Transportation",
    WhyChoosedescription: "An Ertiga can be arranged for Pune Airport pickup and drop services, providing enough space for passengers and luggage while travelling between the airport, home, hotel, or office."
  },
  {
    WhyChooseheading: "Useful for Weekend Trips & Holidays",
    WhyChoosedescription: "Plan family vacations, weekend getaways, sightseeing tours, and outstation holidays with an Ertiga that offers comfortable seating for multiple passengers and adequate luggage space."
  },
  {
    WhyChooseheading: "Suitable for Events & Family Functions",
    WhyChoosedescription: "Ertiga rental can be useful for weddings, family functions, social events, guest transportation, corporate gatherings, and other occasions where a spacious passenger vehicle is required."
  },
  {
    WhyChooseheading: "Driver-Provided Rental Option",
    WhyChoosedescription: "Customers looking for a chauffeur-driven vehicle can arrange an Ertiga with a professional driver, allowing them to focus on their travel plans instead of handling the route and driving."
  },
  {
    WhyChooseheading: "Book an Ertiga with Garud Cab Service",
    WhyChoosedescription: "Share your pickup location, destination, travel date, passenger count, rental duration, and local or outstation requirement to arrange a suitable Ertiga rental in Pune."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Ertiga on Rent in Pune?",
    answer: "Yes, Garud Cab Service provides Ertiga rental services in Pune for local travel, airport transfers, outstation trips, family travel, events, and other transportation requirements."
  },
  {
    question: "Can I rent an Ertiga for outstation travel from Pune?",
    answer: "Yes, Ertiga rental can be arranged for suitable outstation routes from Pune based on your destination, travel dates, and rental requirements."
  },
  {
    question: "Is Ertiga suitable for family trips?",
    answer: "Yes, the Ertiga is a practical option for families and small groups because of its comfortable seating arrangement and useful luggage space."
  },
  {
    question: "Can I hire an Ertiga for Pune Airport pickup?",
    answer: "Yes, Ertiga airport pickup and drop services can be arranged for passengers travelling to or from Pune Airport."
  },
  {
    question: "Can I rent an Ertiga for a wedding function?",
    answer: "Yes, Ertiga rental can be arranged for weddings, family functions, guest transportation, social events, and other special occasions."
  },
  {
    question: "Is the Ertiga available with a driver?",
    answer: "Yes, chauffeur-driven Ertiga rental can be arranged for customers who prefer a convenient travel experience with a professional driver."
  },
  {
    question: "Can I hire an Ertiga for a one-day trip?",
    answer: "Yes, one-day Ertiga rental can be arranged for local sightseeing, family outings, events, airport requirements, and suitable short-distance travel plans."
  },
  {
    question: "Can I use the Ertiga for corporate transportation?",
    answer: "Yes, Ertiga rental is suitable for employee travel, meetings, client visits, corporate events, conferences, and other business transportation requirements."
  },
  {
    question: "Can I rent an Ertiga for a weekend getaway?",
    answer: "Yes, an Ertiga can be hired for weekend trips, holidays, sightseeing tours, and outstation journeys from Pune."
  },
  {
    question: "How can I book an Ertiga on Rent in Pune?",
    answer: "Share your pickup location, destination, travel date, number of passengers, rental duration, and driver requirement with Garud Cab Service to arrange the Ertiga."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Kapse",
    feedback: "We rented an Ertiga in Pune for a family weekend trip. The vehicle had enough room for our passengers and luggage, making the journey comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Shah",
    feedback: "I arranged an Ertiga with a driver for a family function. The vehicle was spacious and the rental arrangement worked well for our group transportation needs.",
    rating: 5
  }
];










  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Pune",
  "image": "https://garudcabs.com/assets/images/ertiga-on-rent-in-pune.webp",
  "description": "Book an Ertiga On Rent in Pune with Garud Cab for comfortable, spacious, and dependable local and outstation travel. Get Maruti Ertiga rental and cab services in Pune for airport transfers, family trips, corporate travel, sightseeing, Pune to Mumbai journeys, and long-distance routes with flexible rental and per-kilometer options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/ertiga-on-rent-in-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>Ertiga On Rent in Pune | Ertiga Cab & Rental | +91 9970007784</title>

  <meta
    name="description"
    content="Book Ertiga on Rent in Pune with Garud Cab for comfortable local, airport, and outstation travel. Get Maruti Ertiga rental, cab, and taxi services with flexible rental and per-kilometer options for family and corporate journeys."
  />

  <meta
    name="keywords"
    content="Ertiga on rent in Pune, Ertiga on rent Pune, Ertiga car on rent in Pune, Ertiga CNG on rent in Pune, Ertiga rent in Pune, Ertiga rent per km in Pune, Ertiga rental Pune, Maruti Ertiga on rent in Pune, Ertiga cab in Pune, Ertiga taxi in Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigaonrentinpune;